/**
 * Keep the pinned "Scrolling boxes" section's GSAP ScrollTrigger positions accurate.
 *
 * Content above the section — an async review widget, lazy-loaded images, web
 * fonts, the background video — can grow the page height *after* ScrollTrigger has
 * measured where to pin. The cached pin start then becomes stale, so on a quick
 * scroll the section engages its pin too early and overlaps the content above it.
 *
 * ScrollTrigger only auto-refreshes on window `resize` and `load`, which misses
 * this later async content. Watch for real page-height changes and refresh so the
 * pin stays correct. Kept here (custom JS) so theme updates don't overwrite it.
 */
(function () {
  function init() {
    if (!document.querySelector('scrolling-boxes')) return;

    const root = document.documentElement;
    let lastHeight = root.scrollHeight;
    let scheduled = false;
    let refreshing = false;
    let observer;

    const check = function () {
      scheduled = false;
      if (refreshing || typeof ScrollTrigger === 'undefined') return;

      const height = root.scrollHeight;
      if (height === lastHeight) return;

      refreshing = true;
      // Pause observing so ScrollTrigger's own pin-spacer DOM edits during the
      // refresh don't feed straight back in and cause a loop.
      observer.disconnect();
      ScrollTrigger.refresh();
      lastHeight = root.scrollHeight;
      observer.observe(document.body, { childList: true, subtree: true });
      refreshing = false;
    };

    const schedule = function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(check, 250);
    };

    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
